"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Value = void 0;
const aspect_1 = require("./aspect");
class Value extends aspect_1.Aspect {
    constructor($key, description, schema, initializer) {
        super($key, description);
        this.schema = schema;
        this.apply(initializer);
    }
}
exports.Value = Value;
//# sourceMappingURL=value.js.map